import { FC } from "react";
import styles from "./ChosenTimeSlot.module.scss";
import Bag from "@/assets/images/Bag";
import usePickupStore from "@/stores/pickup";
import { pickupTimeShort } from "@/helpers/pickup";
import useCashRegisterStore from "@/stores/cash-register";
import { useTranslation } from "react-i18next";

const ChosenTimeSlot: FC = () => {
  const { t } = useTranslation();
  const { pickupStartAt } = usePickupStore();
  const address = useCashRegisterStore().getAddress();

  return (
    <div className={styles.container}>
      <span>{t("pickup.yourInfoPage.chosenTimeSlot")}:</span>
      {pickupStartAt && (
        <div className={styles.dateRow}>
          <Bag fill="white" />
          <h4>{pickupTimeShort(pickupStartAt)}</h4>
        </div>
      )}
      {address && <span>{address}</span>}
    </div>
  );
};

export default ChosenTimeSlot;
